export enum DynamicReferenceType {
  FormElement = 0,
  SubmissionId = 1,
  OriginalSubmitter = 2,
  StepCompleter = 3,
  StepStart = 4,
  StepEnd = 5,
  InitialSubmissionStart = 6,
  InitialSubmissionEnd = 7,
  CertificateGeneration = 8,
  AwardedLicense = 9,
  ObjectModelProperty = 10,
  ProfileConfig = 11,
  ObjectModelBulkActionInstanceCount = 12,
  CertificateMapping = 13,
  ObjectModelRecordMetadata = 14,
  Formula = 15,
  ProcessFlowVariable = 16,
  PaymentsTotalCost = 17,
  PaymentsType = 18,
  PaymentsDate = 19,
  PaymentsLineItem = 20,
  // This is a general all-purpose reference, used in ProcessFlow
  // ids in the formula are the ids of +ReferencePath+s that contain an array of nodes
  // which are the instructions on how to find the reference
  Reference = 21,
  Form = 22,
  ObjectModel = 23,
  ObjectModelRelation = 24,
  ApiEndpoint = 25,

  DynamicInput = 26,
  FormMetaData = 27,
  PaymentsReceiptNumber = 28,
  ProcessFlowMetadata = 29,
  ApiURLParameter = 30,
  ApiHeader = 31
}
